import React from 'react';
import styled from 'styled-components';


const Container = styled.div`
  font-family: 'Impact', sans-serif;
  text-transform: uppercase;
  display: flex;
  flex-direction: column;
  margin-bottom: 50px;
  max-width: 200px;
  @media(min-width: ${({ theme }) => theme.screenSizeWidth.medium}){
    margin: 0 50px
  }
`;

const Number = styled.span`
  text-align: center;
  font-size: ${({ theme }) => theme.headingSize.large}
`;

const Caption = styled.span`
  text-align: center;
  color: ${({ theme }) => theme.colors.white};
  font-size: ${({ theme }) => theme.fontSize.medium};
  margin-top: 15px;
`;


interface NumberWithCaptionProps {
  captionText: string,
  number: string,
}

const NumberWithCaption = ({ captionText, number }: NumberWithCaptionProps) => (
  <Container>
    <Number>
      {number}
    </Number>
    <Caption>
      {captionText}
    </Caption>
  </Container>
);

export default NumberWithCaption;
